import { render, staticRenderFns } from "./GraphDetail27.vue?vue&type=template&id=510f853f&scoped=true"
import script from "./GraphDetail27.vue?vue&type=script&lang=js"
export * from "./GraphDetail27.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f853f",
  null
  
)

export default component.exports